import React from "react";

const PauseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clipPath3813049119">
          <path
            d="M0 0L32 0L32 32L0 32L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath3813049119)">
        <path
          d="M0 -1C-0.55228 -1 -1 -0.55228 -1 0L-1 16C-1 16.5523 -0.55228 17 0 17C0.55228 17 1 16.5523 1 16L1 0C1 -0.55228 0.55228 -1 0 -1Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 10.6672 8)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M0 -1C-0.55228 -1 -1 -0.55228 -1 0L-1 16C-1 16.5523 -0.55228 17 0 17C0.55228 17 1 16.5523 1 16L1 0C1 -0.55228 0.55228 -1 0 -1Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 21.3328 8)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default PauseIcon;
